import {
  Leaf, Brain, Infinity, Flame, Atom, Dna, Activity, HeartPulse, Sparkles,
  UserRound, ShieldCheck, FlaskConical, Zap, Microscope, Droplet, Pill, Target, Star,
  Snowflake, Lock, Ruler, Package, Box,
} from "lucide-react";

export const ICONS = {
  Leaf, Brain, Infinity, Flame, Atom, Dna, Activity, HeartPulse, Sparkles,
  UserRound, ShieldCheck, FlaskConical, Zap, Microscope, Droplet, Pill, Target, Star,
  Snowflake, Lock, Ruler, Package, Box,
};

export const ICON_NAMES = Object.keys(ICONS);

export const Icon = ({ name, ...props }) => {
  const C = ICONS[name] || Atom;
  return <C {...props} />;
};
